<!--
  ~ Copyright 2021-2023 Aion Technology LLC
  ~
  ~ Licensed under the Apache License, Version 2.0 (the "License");
  ~ you may not use this file except in compliance with the License.
  ~ You may obtain a copy of the License at
  ~
  ~     http://www.apache.org/licenses/LICENSE-2.0
  ~
  ~ Unless required by applicable law or agreed to in writing, software
  ~ distributed under the License is distributed on an "AS IS" BASIS,
  ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  ~ See the License for the specific language governing permissions and
  ~ limitations under the License.
  -->

<div class="container">
  <p class="hero-text">YOU ARE CHANGING<br/>YOUNG LIVES FOREVER</p>
  <img class="home-img" src="../../../assets/home-background.png" alt="">
  <div class="arc-container">
    <p class="contact-message">If you need any assistance or have<br/>any questions, please contact the support team</p>
    <a href="mailto:dale.baugh@theliveyourdreamfoundation.org">
      <button mat-flat-button color="primary" class="button login-button">Contact</button>
    </a>
    <img class="arc-img" src="../../../assets/blue-arc-home.png">
  </div>
</div>
